"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createD2CMessage = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const message_1 = require("./message");
exports.NAMESPACE = 'Culligan.Protocol.V2.System';
const createD2CMessage = (namespace, commands) => {
    return (0, message_1.createMessage)('command', effect_1.Schema.Union(...commands)).annotations({
        identifier: `${namespace}.CommandC2DMessage`,
        title: 'Command Message',
        description: 'A Cloud-To-Device message on the "command" channel',
    });
};
exports.createD2CMessage = createD2CMessage;
//# sourceMappingURL=command.js.map